module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/hsptl-095d5fb37262a61418632a0bd92666b5.svg";